import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  HalfContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import AddOnsTable from './tables/add-ons-table';
import DetailTable from './tables/detail-table';
import GuestTable from './tables/guest-table';

export default function DocumentItems() {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const documentSales = useWatch({
    control,
    name: 'approvalable.documentSales',
  });

  return (
    <>
      {documentSales.map((documentSale, idx) => {
        const guests = documentSale.documentSaleGuests;
        const documentType = documentSale.documentType;
        return (
          <React.Fragment key={documentSale.id}>
            <CardSection>
              <FullContainer $style={fullContaienrStyle}>
                <div style={{ flex: 1 }}>
                  <Text variant="HeadingXSmall">
                    {t('document:document_details')} {idx + 1}
                  </Text>
                </div>
                <Input
                  type="check-box"
                  name={`approvalable.documentSales.${idx}.reminder`}
                  label={t('ticketSales:set_reminder')}
                />
              </FullContainer>
              <FullContainer $style={fullContaienrStyle}>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`approvalable.documentSales.${idx}.documentType`}
                    label={t('document:document_type')}
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="date-time"
                    label={t('common:document_receive_date')}
                    name={`approvalable.documentSales.${idx}.documentReceiveDate`}
                  />
                </HalfContainer>
              </FullContainer>

              <GuestTable parentIndex={idx} />
              {guests.map((guest) => {
                return (
                  <React.Fragment key={guest.id}>
                    <Separator gap={24} direction="vertical">
                      <Text variant="LabelMedium">{guest?.guestName}</Text>
                    </Separator>
                    <DetailTable
                      detail={guest.details}
                      documentType={documentType?.toLowerCase()}
                    />
                  </React.Fragment>
                );
              })}
              <AddOnsTable parentIndex={idx} />
            </CardSection>
            <Separator gap={24} />
          </React.Fragment>
        );
      })}
    </>
  );
}

const fullContaienrStyle = { display: 'flex', justifyContent: 'space-between' };
